/**
 * Abschnitt eines Formulars (REQ-27 §2.1): Überschrift klein in Großbuchstaben wie die
 * Abschnittsköpfe des Dashboards, darunter das zweispaltige Feldraster. Ohne `title` bleibt
 * nur das Raster — so brauchen die Reiter des Containers keine zweite Überschrift neben
 * ihrer Reiterbeschriftung.
 */

import type { ReactNode } from 'react';

export interface FormSectionProps {
  title?: string;
  children: ReactNode;
}

export function FormSection(props: FormSectionProps) {
  return (
    <section className="iwm-form-section">
      {props.title === undefined ? null : <h3 className="iwm-form-section-title">{props.title}</h3>}
      <div className="iwm-form-grid">{props.children}</div>
    </section>
  );
}

export default FormSection;
